import { Component, Input, OnInit } from '@angular/core';
import { DynamicViewField } from 'piwe-front-swagger-client';
import { FormBuilder, FormGroup } from '@angular/forms';
import { InputType } from '../transforming-input/transforming-input.component';

@Component({
  selector: 'app-inline-table',
  templateUrl: './inline-table.component.html',
  styleUrls: ['./inline-table.component.scss']
})
export class InlineTableComponent implements OnInit {
  @Input() field!: DynamicViewField;
  @Input() form!: FormGroup;
  @Input() controlName!: string;
  @Input() label!: string;
  @Input() isEditModeActive: boolean = false;

  modalForm!: FormGroup;
  isModalOpen = false;
  isEditing = false;
  editingIndex: number | null = null;

  get tableData(): any[] {
    return this.form.get(this.controlName)?.value || [];
  }

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    if (!this.form.contains(this.controlName)) {
      this.form.addControl(this.controlName, this.fb.control([]));
    }
  }

  private initModalForm() {
    const group: any = {};
    this.field.table_config?.columns.forEach(column => {
      group[column!.name!] = [''];
    });
    this.modalForm = this.fb.group(group);
  }

  getInputType(kind: DynamicViewField.KindEnum | undefined): InputType {
    // Map DynamicViewField kinds to InputTypes
    switch (kind) {
      case 'STRING': return InputType.Text;
      case 'INTEGER': return InputType.Number;
      case 'DECIMAL': return InputType.Number;
      case 'BOOLEAN': return InputType.Boolean;
      case 'TEXT': return InputType.Text;
      case 'DROPDOWN': return InputType.Select;
      case 'TAGS': return InputType.Tags;
      case 'DATETIME': return InputType.Date;
      case 'INLINE_TABLE': return InputType.InlineTable;
      default: return InputType.Text;
    }
  }

  formatValue(value: any, column: DynamicViewField): string {
    if (column.kind === 'DROPDOWN' && column.dropdown_options) {
      const option = column.dropdown_options.find(opt => opt.id === value);
      return option?.title || value;
    }
    return value?.toString() || '-';
  }

  // Modal handlers
  openAddModal() {
    this.isEditing = false;
    this.editingIndex = null;
    this.initModalForm();
    this.isModalOpen = true;
  }

  editRow(index: number) {
    this.isEditing = true;
    this.editingIndex = index;
    this.initModalForm();
    this.modalForm.patchValue(this.tableData[index]);
    this.isModalOpen = true;
  }

  saveRow() {
    if (this.modalForm.valid) {
      const newData = [...this.tableData];
      if (this.isEditing && this.editingIndex !== null) {
        newData[this.editingIndex] = this.modalForm.value;
      } else {
        newData.push(this.modalForm.value);
      }
      this.form.get(this.controlName)?.setValue(newData);
      this.closeModal();
    }
  }

  deleteRow(index: number) {
    const newData = [...this.tableData];
    newData.splice(index, 1);
    this.form.get(this.controlName)?.setValue(newData);
  }

  closeModal() {
    this.isModalOpen = false;
    this.modalForm = null!;
  }
}
